interface Props {
  content: string;
  creator: string;
  createdAt: string;
}

export default function NoteBox({ content, createdAt, creator }: Props) {
  return (
    <div className="bg-slate-100 rounded-md p-2 animate-fadeIn">
      <div className="text-zinc-500">{creator}</div>
      <div className="text-zinc-900 my-1">{content}</div>
      <div className="text-left text-xs text-zinc-500">
        {new Date(createdAt).toLocaleString('fa-IR', {
          dateStyle: 'medium',
          timeStyle: 'short'
        })}
      </div>
    </div>
  );
}
